import React from "react";
import { ICONS } from "@/components/site/Needs";
import { Check } from "lucide-react";
import { HOME } from "@/constants/testIds";

export default function Areas({ areas = [] }) {
  return (
    <section id="areas" className="py-16 md:py-24" style={{ background: "var(--ev-bg-2)" }}>
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <div className="eyebrow">Wellness & Coaching Categories</div>
        <h2 className="font-serif-ev mt-3 text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight max-w-3xl">
          Guidance for every core of your life.
        </h2>
      </div>

      <div className="mt-10 md:mt-14 pl-5 md:pl-10">
        <div className="flex gap-5 overflow-x-auto no-scrollbar pr-5 md:pr-10 pb-4 snap-x">
          {areas.map((a, i) => {
            const Icon = ICONS[a.icon] || ICONS.compass;
            return (
              <article
                key={a.id}
                data-testid={HOME.areaCard(i)}
                className="min-w-[280px] sm:min-w-[340px] md:min-w-[380px] snap-start smooth-hover"
              >
                <div className="ev-card-photo relative" style={{ aspectRatio: "4/5" }}>
                  <img src={a.image_url} alt={a.title} className="w-full h-full object-cover absolute inset-0" loading="lazy" />
                  <div className="absolute left-4 bottom-4 right-4">
                    <div className="ev-pill">
                      <span className="w-8 h-8 rounded-full grid place-items-center" style={{ background: "var(--ev-peach)" }}>
                        <Icon className="w-4 h-4" style={{ color: "var(--ev-blue-2)" }} />
                      </span>
                      <span className="font-medium text-sm" style={{ color: "var(--ev-ink)" }}>{a.title}</span>
                    </div>
                  </div>
                </div>
                <p className="mt-4 text-[15px] max-w-[380px]" style={{ color: "var(--ev-muted)" }}>
                  {a.description}
                </p>
                <a href="#book" className="mt-3 inline-flex items-center gap-2 text-sm font-medium" style={{ color: "var(--ev-blue-2)" }}>
                  <Check className="w-4 h-4" /> Explore this path
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
